import React, { createContext, useContext, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { DEFAULT_REQUEST } from './constants';
import { trackEvent } from '../../store/UserActivity/actions';
import {
  CREATIVE_ANALYTICS,
  ADD_TO_REQUEST,
} from '../../store/UserActivity/constants';

const defaultContextValue = {
  requests: [DEFAULT_REQUEST],
  currentIndex: 0,
  currentRequest: DEFAULT_REQUEST,
  descriptions: [''],
  overviews: [''],
  requestOpen: false,
  setRequests: () => {},
  setCurrentIndex: () => {},
  setDescriptions: () => {},
  setOverviews: () => {},
  setRequestOpen: () => {},
};

const CreativeRequestContext = createContext(defaultContextValue);

export const CreativeRequestProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [requests, setRequests] = useState([DEFAULT_REQUEST]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [descriptions, setDescriptions] = useState(['']);
  const [overviews, setOverviews] = useState(['']);
  const [requestOpen, setRequestOpen] = useState(false);

  const currentRequest = requests[currentIndex];

  const trackAddToRequest = (request_field, label_added) => {
    dispatch(
      trackEvent(CREATIVE_ANALYTICS, ADD_TO_REQUEST, {
        request_field,
        label_added,
      })
    );
  };

  const addToOverview = (
    display,
    url,
    visual_type,
    category,
    value,
    fromReportCard
  ) => {
    const navigate = () => {
      window.location.href = url;
    };

    const isMov = url.includes('.mov');

    const displayText = !fromReportCard ? (
      <a
        href={url}
        onClick={navigate}
        target="_blank"
        rel="noopener noreferrer"
        data-category={category}
        data-label-value={value}
      >
        {display}
      </a>
    ) : (
      <p>{display}</p>
    );

    let asset = (
      <>
        {displayText}
        <img src={url} className="request-overview__img" />
      </>
    );

    if (visual_type === 'video') {
      asset = (
        <>
          {displayText}
          {!isMov && (
            <iframe
              className="ql-video"
              frameborder="0"
              allowfullscreen="true"
              src={url}
            ></iframe>
          )}
        </>
      );
    }

    const update = [...overviews].map((req, i) => {
      if (i === currentIndex) {
        return `${req}${ReactDOMServer.renderToStaticMarkup(asset)}`;
      }
      return req;
    });

    trackAddToRequest('overview', value);
    setOverviews(update);
  };

  const addToOverviewCustom = (str) => {
    const update = [...overviews].map((req, i) => {
      if (i === currentIndex) {
        return `${req}${str}`;
      }
      return req;
    });

    trackAddToRequest('overview', '');
    setOverviews(update);
  };

  const value = {
    requests,
    setRequests,
    currentIndex,
    setCurrentIndex,
    currentRequest,
    descriptions,
    setDescriptions,
    overviews,
    setOverviews,
    requestOpen,
    setRequestOpen,
    addToOverview,
    addToOverviewCustom,
  };

  return (
    <CreativeRequestContext.Provider value={value}>
      {children}
    </CreativeRequestContext.Provider>
  );
};

export const useCreativeRequestGet = () => {
  const context = useContext(CreativeRequestContext);
  if (!context) {
    return defaultContextValue;
  }
  return context;
};

export const useCreativeRequestSet = () => {
  const context = useContext(CreativeRequestContext);
  if (!context) {
    return defaultContextValue;
  }
  return context;
};
